import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#006aff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.666 8.916c2.355.463 4 1.52 4 2.75 0 1.657-2.984 3-6.666 3s-6.667-1.343-6.667-3c0-1.23 1.645-2.287 4-2.75M8 11.333V6m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }, null, -1)
  ]))]))
}
export default { render: render }